import React, { useState, useEffect } from 'react';
import { Box, styled, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
// import DashBoardLink from '../../dashbaordLink/DashboardLink';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import SettingsIcon from '../../../assets/Settings.svg';
import LogoutIcon from '../../../assets/logoutside.svg';
import guide from '../../../assets/centerside.svg';
import DashboardCustomizeSharpIcon from '@mui/icons-material/DashboardCustomizeSharp';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import PhoneBook from '../../../assets/Phonebook.svg';
import topupside from '../../../assets/topupside.svg';
import contactnew from '../../../assets/contactside.svg';
import PhoneImg from '../../../assets/contactUsWhite.svg';
import home from '../../../assets/Filled icons.svg';
import Message from '../../../assets/sendmssgside.svg';
import Welcome from '../../../assets/firstSignupImage.svg';
import Joyride from 'react-joyride';
import CloseIcon from '@mui/icons-material/Close';
import { userLSAuth } from '../../../components/app/features/env';
import { useDispatch, useSelector } from 'react-redux';
import { endtour } from '../../../components/app/features/message/messageSlice';
import { getUserProfile, setShowTour } from '../../../components/app/features/auth/AuthSlice';
import ParroticaLogo from '../../../assets/logoNew.svg';
import Navleft from '../../../assets/navleft.svg';
import Navright from '../../../assets/navright.svg';
import { FaAngleLeft, FaBars } from 'react-icons/fa';
import { Padding } from '@mui/icons-material';

const SidebarWrapper = styled(Box)(
   ({ theme }) => `
          width: ${theme.sidebar.minWidth};
         
          min-width: ${theme.sidebar.minWidth};
          background:#00308F;
          position: fixed;
          top: 0;
          z-index: 1000;
          bottom:0;
          left:0;
         transition: width 0.3s ease-in-out;
         display:flex;
         flex-direction: column;
         justify-content: space-between;
         row-gap:2rem;
         @media (max-width: ${theme.breakpoints.values.myCustomQueryI}px) {
           transform: translateX(-100%);
           transition: transform 0.3s ease-in-out;
        }
								
  `
);

// Add a new styled component for mobile sidebar
const MobileSidebarWrapper = styled(Box)(
   ({ theme }) => `
          width: 250px;
          min-width: 250px;
          background:#00308F;
          position: fixed;
          top: 0;
          z-index: 1001;
          bottom:0;
          left:0;
          transition: transform 0.3s ease-in-out;
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          row-gap:2rem;
          @media (min-width: ${theme.breakpoints.values.myCustomQueryI + 1}px) {
           display: none;
        }
  `
);

// Add overlay for mobile
const MobileOverlay = styled(Box)(
   () => `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;
      display: block;
  `
);

// Mobile toggle button
const MobileToggleButton = styled(Box)(
   ({ theme }) => `
      position: fixed;
      top: 20px;
      left: 20px;
      z-index: 1002;
      background: #00308F;
      color: white;
      padding: 10px;
      border-radius: 8px;
      cursor: pointer;
      display: none;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      
      @media (max-width: ${theme.breakpoints.values.myCustomQueryI}px) {
         display: flex;
      }
  `
);

const boxSX = {
   py: '12px',
   pl: '22px',
   mt: '10px',
   mx:'10px',
   color: '#ffffff',
   cursor: 'pointer',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'flex-start',
   
   // Style for SVG images in normal state
   '& img': {
      filter: 'brightness(0) invert(1)', // Makes white
      transition: 'filter 0.2s ease',
   },

   '&:hover': {
      color: '#00308F',
      backgroundColor: 'white',
      borderRadius:'10px',

      // Change SVG icon color on hover
      '& img': {
         filter: 'brightness(0) saturate(100%) invert(15%) sepia(100%) saturate(3000%) hue-rotate(220deg) brightness(95%) contrast(101%)',
      }
   }
};

const collapsedBoxSX = {
   py: '12px',
   mt: '10px',
   mx:'10px',
   color: '#ffffff',
   cursor: 'pointer',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center', 
   
   // Style for SVG images in normal state
   '& img': {
      filter: 'brightness(0) invert(1)', // Makes white
      transition: 'filter 0.2s ease',
   },

   '&:hover': {
      color: '#00308F',
      backgroundColor: 'white',
      borderRadius:'10px',

      // Change SVG icon color on hover
      '& img': {
         filter: 'brightness(0) saturate(100%) invert(15%) sepia(100%) saturate(3000%) hue-rotate(220deg) brightness(95%) contrast(101%)',
      }
   }
};

const activeLink = {
   py: '12px',
   pl: '22px',
   mt: '17px',
   cursor: 'pointer',
   color: '#00308F',
   backgroundColor: '#fff',
   borderRadius:'10px',
   mx:'10px',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'flex-start',
   
   // Style for SVG images in active state (blue)
   '& img': {
      filter: 'brightness(0) saturate(100%) invert(15%) sepia(100%) saturate(3000%) hue-rotate(220deg) brightness(95%) contrast(101%)',
      transition: 'filter 0.2s ease',
   }
};

const activeLinkCollapsed = {
   py: '12px',
   mt: '17px',
   cursor: 'pointer',
   color: '#00308F',
   backgroundColor: '#fff',
   borderRadius:'10px',
   mx:'10px',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center', // Center icons when collapsed
   
   // Style for SVG images in active state (blue)
   '& img': {
      filter: 'brightness(0) saturate(100%) invert(15%) sepia(100%) saturate(3000%) hue-rotate(220deg) brightness(95%) contrast(101%)',
      transition: 'filter 0.2s ease',
   }
};

const Sidebar = ({ getLogOutState, isOpen: propIsOpen, getHamState }) => {
   const location = useLocation();
   const navigate = useNavigate();
   const [runTour, setRunTour] = useState(false);
   const [showStartDialog, setShowStartDialog] = useState(false);
   const currentUser = userLSAuth();
   const showAppIntro = useSelector((state) => state.auth.showTour);
   const showTour = useSelector((state) => state.auth.showTour);
   const dispatch = useDispatch();
   const [isMobile, setIsMobile] = React.useState(false);
   const [mobileOpen, setMobileOpen] = React.useState(false);

     const isOpen = propIsOpen;

   // Check user onboarding status on component mount
   useEffect(() => {
    
      if (showAppIntro) {
         setShowStartDialog(true);
         
      } 
   }, [showAppIntro]);

   // Use useEffect to watch for changes in showAppIntro
   useEffect(() => {
      if (showAppIntro === false) {
         setRunTour(false);
         setShowStartDialog(false);
      }
   }, [showAppIntro]);

   const updateMobileState = () => {
      // Make sure this matches your theme breakpoint
      if (window.innerWidth <= 1120) {
         setIsMobile(true);
      } else {
         setIsMobile(false);
         setMobileOpen(false);
      }
   };

   const handleClick = () => {
      if (getHamState) {
         getHamState(!isOpen);
      }
   };

   const handleClickMobile = () => {
     setMobileOpen(!mobileOpen);
   };

   // Close mobile sidebar when clicking on overlay
   const handleOverlayClick = () => {
      setMobileOpen(false);
   };

   React.useEffect(() => {
      window.addEventListener('resize', updateMobileState);
      updateMobileState(); // Call once on mount
      
      // Clean up the event listener when the component unmounts
      return () => {
         window.removeEventListener('resize', updateMobileState);
      };
   }, []);

   const handleSkipTour = () => {
      const userId = currentUser?.id;
      if (userId) {
         dispatch(setShowTour(false))
         dispatch(getUserProfile());
         dispatch(endtour(userId)).then(() => {
            setShowStartDialog(false);
            setRunTour(false);
            setTourCompleted(true);
           
          
         });
      } else {
        
         setShowStartDialog(false);
         setRunTour(false);
         setTourCompleted(true);
      }
   };

   const steps = [
      {
         target: '[data-tour="dashboard"]',
         content: 'Get an overview of your SMS unit balance, recent messages, app updates and quick actions.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Your control center'
      },
      {
         target: '[data-tour="send-message"]',
         content: 'Craft your messages, select recipients, and send in just a few taps. Simple, fast, and effective.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Send SMS in seconds'
      },
       {
         target: '[data-tour="contacts"]',
         content: 'Save, organize, and group your contacts—or import them in bulk via CSV or VCF for seamless messaging.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Import & manage your contacts'
      },
      {
         target: '[data-tour="top-up"]',
         content: 'Easily top up your wallet to keep your messages flowing. Multiple payment options available.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Never run out of SMS units'
      },
       {
    target: '[data-tour="guide-center"]',
    content:
      'Access tutorials, FAQs, and helpful resources any time you need assistance with Parrotica.',
    disableBeacon: true,
    placement: 'right',
    offset: 20,
    title: 'Guide Center',
  },
     
      {
         target: '[data-tour="settings"]',
         content: 'Apply for your Sender ID, update profile details, and tweak preferences to suit your needs.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Customize your experience'
      },
   ];

   const handleStartTour = () => {
      setShowStartDialog(false);
      if (showAppIntro) {
         setRunTour(true);
      }
   };
   

   const handleCloseDialog = () => {
      const userId = currentUser?.id;
      if (userId) {
         dispatch(endtour(userId)).then(() => {
            setShowStartDialog(false)
            dispatch(getUserProfile())
         });
      }
   };

   const renderSidebarContent = () => (
      <>
         <Box>
            <Box display={'flex'} style={{
                cursor: 'pointer',
                background:'#00308F',
                padding: '10px',
                alignItems: 'center',
                justifyContent: (isOpen || isMobile) ? 'space-between' : 'center',
               
             }}>
               {(isOpen || isMobile) && (
                  <img
                     src={ParroticaLogo}
                     height="32px"
                     alt="LOGO"
                     style={{
                        cursor: 'pointer',
                        marginTop:'1rem'
                     }}
                     onClick={() => navigate('/dashboard')}
                  />
               )}
               
               <Box
                  sx={{
                     cursor: 'pointer',
                     display: 'inline-block',
                     marginLeft: (isOpen || isMobile) ? '1rem' : '0',
                  }}
                  onClick={isMobile ? handleClickMobile : handleClick}
               >
                  {(isMobile ? mobileOpen : isOpen) ? (
                     <img src={Navleft} style={{marginTop: '1rem'}} alt="collapse" />
                  ) : (
                     <img src={Navright} style={{marginTop: '1rem'}} alt="expand" />
                  )}
               </Box>
            </Box>

            <Link
               to="/dashboard"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="dashboard"
               onClick={isMobile ? handleClickMobile : undefined}
            >
               <Box
                  sx={location.pathname == '/dashboard' 
                     ? ((isOpen || isMobile) ? activeLink : activeLinkCollapsed) 
                     : ((isOpen || isMobile) ? boxSX : collapsedBoxSX)
                  }
               >
                  <img src={home} alt="dashboard" style={{ width: '24px', height: '24px' }} />
                  {(isOpen || isMobile) && (
                     <Typography variant="h5" fontSize="16px" fontWeight={500} sx={{ ml: 1 }}>
                        Dashboard
                     </Typography>
                  )}
               </Box>
            </Link>

            <Link
               to="/send-message"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="send-message"
               onClick={isMobile ? handleClickMobile : undefined}
            >
               <Box
                  sx={location.pathname.includes('send-message')
                     ? ((isOpen || isMobile) ? activeLink : activeLinkCollapsed)
                     : ((isOpen || isMobile) ? boxSX : collapsedBoxSX)
                  }
               >
                  <img
                     src={Message}
                     alt="message"
                     style={{ width: '24px', height: '24px' }}
                  />
                  {(isOpen || isMobile) && (
                     <Typography variant="h5" fontSize="16px" fontWeight={500} sx={{ ml: 1 }}>
                        Send Message
                     </Typography>
                  )}
               </Box>
            </Link>

            <Link
               to="/contacts"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="contacts"
               onClick={isMobile ? handleClickMobile : undefined}
            >
               <Box
                  sx={location.pathname.includes('contacts') 
                     ? ((isOpen || isMobile) ? activeLink : activeLinkCollapsed) 
                     : ((isOpen || isMobile) ? boxSX : collapsedBoxSX)
                  }
               >
                  <img src={contactnew} style={{ width: '24px', height: '24px' }} alt="contacts" />
                  {(isOpen || isMobile) && (
                     <Typography variant="h5" fontSize="16px" fontWeight={500} sx={{ ml: 1 }}>
                        Contacts
                     </Typography>
                  )}
               </Box>
            </Link>

            <Link
               to="/top-up"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="top-up"
               onClick={isMobile ? handleClickMobile : undefined}
            >
               <Box
                  sx={location.pathname.includes('top-up') 
                     ? ((isOpen || isMobile) ? activeLink : activeLinkCollapsed) 
                     : ((isOpen || isMobile) ? boxSX : collapsedBoxSX)
                  }
               >
                  <img
                     src={topupside}
                     alt="top-up"
                     style={{ width: '24px', height: '24px' }}
                  />
                  {(isOpen || isMobile) && (
                     <Typography variant="h5" fontSize="16px" fontWeight={500} sx={{ ml: 1 }}>
                        Top-Up
                     </Typography>
                  )}
               </Box>
            </Link>

         
         </Box>

         <Box>
            <Link
               to="/dashboard/Guide"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="guide-center"
               onClick={isMobile ? handleClickMobile : undefined}
            >
               <Box
                  sx={location.pathname.includes('dashboard/Guide')
                     ? ((isOpen || isMobile) ? activeLink : activeLinkCollapsed)
                     : ((isOpen || isMobile) ? boxSX : collapsedBoxSX)
                  }
               >
                  <img
                     src={guide}
                     alt="contact support"
                     style={{ width: '24px', height: '24px' }}
                  />
                  {(isOpen || isMobile) && (
                     <Typography variant="h5" fontSize="16px" fontWeight={500} sx={{ ml: 1 }}>
                        Guide Center
                     </Typography>
                  )}
               </Box>
            </Link>

            <Link
               to="/settings"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="settings"
               onClick={isMobile ? handleClickMobile : undefined}
            >
               <Box
                  sx={location.pathname == '/settings' 
                     ? ((isOpen || isMobile) ? activeLink : activeLinkCollapsed) 
                     : ((isOpen || isMobile) ? boxSX : collapsedBoxSX)
                  }
               >
                  <img
                     src={SettingsIcon}
                     alt="settings"
                     style={{ width: '24px', height: '24px' }}
                  />
                  {(isOpen || isMobile) && (
                     <Typography variant="h5" fontSize="16px" fontWeight={500} sx={{ ml: 1 }}>
                        Settings
                     </Typography>
                  )}
               </Box>
            </Link>

            <Box
               sx={(isOpen || isMobile) ? boxSX : collapsedBoxSX}
               onClick={() => {
                  if (getLogOutState) {
                     getLogOutState(true);
                  }
                  if (isMobile) {
                     handleClickMobile();
                  }
               }}
            >
               <img
                  src={LogoutIcon}
                  alt="logout"
                  style={{ width: '24px', height: '24px' }}
               />
               {(isOpen || isMobile) && (
                  <Typography variant="h5" fontSize="16px" fontWeight={500} sx={{ ml: 1 }}>
                     Log out
                  </Typography>
               )}
            </Box>
         </Box>
      </>
   );

   return (
      <>
         {/* Get Started Dialog */}
       <Dialog
  open={showStartDialog}
  onClose={handleSkipTour}
  maxWidth="sm"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 1,
      p: 1,
      textAlign: "center",
    },
  }}
>


  {/* Image inside circle */}
  <Box
    sx={{
      width: 120,
      height: 120,
      borderRadius: "50%",
      backgroundColor: "#f5f7fa",
      mx: "auto",
      mt: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <img src={Welcome} alt="welcome" style={{ width: "80px" }} />
  </Box>


  {/* Description */}
  <DialogContent sx={{ px: 2 }}>
   <Typography className="font-cormorant" variant="h5" sx={{color:'#333333',fontWeight:'600',fontSize:{xs:'1rem', sm:'1.9rem'}}} gutterBottom>
          You're all set,  {userLSAuth()?.fullName && userLSAuth()?.fullName + '!'}
        </Typography>
        <Typography variant="body2" sx={{color:'#2E2C21',fontWeight:'400'}} mb={0}>
          We've personalized your dashboard based on your goals.
        </Typography>
        <Typography variant="body2" sx={{color:'#2E2C21',fontWeight:'400'}} mb={4}>
          Take a quick guided tour to get familiar with key features.
        </Typography>
  </DialogContent>

  {/* Actions */}
  <DialogActions sx={{ flexDirection: "column", px: 3, pb: 3 }}>
    <Button
      fullWidth
      variant="contained"
      sx={{
        mb: 2,
        background: "#0040BF",
        "&:hover": { backgroundColor: "#0040CF" },
      }}
      onClick={handleStartTour}
    >
      Take a quick tour
    </Button>
    <Button
      fullWidth
      sx={{ color: "#58564d" }}
      onClick={handleSkipTour}
    >
      Skip tour
    </Button>
  </DialogActions>
</Dialog>


         {/* Mobile Toggle Button */}
         {isMobile && !mobileOpen && (
            <MobileToggleButton onClick={handleClickMobile}>
               <FaBars size={20} />
            </MobileToggleButton>
         )}

         {/* Desktop Sidebar */}
         {!isMobile && (
            <SidebarWrapper
               sx={{
                  width: isOpen ? '250px' : '80px',
               }}
            >
               {renderSidebarContent()}
               {runTour && (
                  <Joyride
                     steps={steps}
                     run={runTour}
                     continuous={true}
                     showSkipButton={true}
                     showProgress={false}
                     disableOverlayClose={true}
                     disableBeacon={true}
                     disableScrolling={true}
                     styles={{
                        options: {
                           primaryColor: '#0040BF',
                           zIndex: 10000,
                           backgroundColor: '#fff',
                           overlayColor: 'rgba(0, 0, 0, 0.5)',
                           arrowColor: '#ffffff',
                           width: 800,
                           transitionDuration: 0
                        },
                        tooltip: {
                           padding: '32px',
                           borderRadius: '8px',
                           boxShadow: '0 2px 15px rgba(0, 0, 0, 0.1)',
                           backgroundColor: '#ffffff',
                           maxWidth: '800px',
                        },
                        tooltipContainer: {
                           textAlign: 'left',
                           backgroundColor: '#ffffff',
                        },
                        tooltipTitle: {
                           fontSize: '24px',
                           fontWeight: '600',
                           marginBottom: '16px',
                           color: '#333',
                        },
                        tooltipContent: {
                           fontSize: '16px',
                           lineHeight: 1.6,
                           color: '#555',
                           marginBottom: '32px',
                        },
                        buttonNext: {
                           backgroundColor: '#0040BF',
                           color: 'white',
                           padding: '12px 24px',
                           fontSize: '16px',
                           borderRadius: '4px',
                           fontWeight: '500',
                           cursor: 'pointer',
                           transition: 'all 0.2s ease',
                           '&:hover': {
                              backgroundColor: '#0033a0'
                           }
                        },
                        buttonBack: {
                           color: '#666',
                           padding: '12px 0',
                           fontSize: '16px',
                           marginRight: '20px',
                           backgroundColor: 'transparent',
                           cursor: 'pointer',
                           transition: 'all 0.2s ease',
                           '&:hover': {
                              color: '#333'
                           }
                        },
                        buttonSkip: {
                           color: '#777',
                           fontSize: '16px',
                           fontWeight: '400',
                           position: 'absolute',
                           right: '32px',
                           top: '32px',
                           cursor: 'pointer',
                           transition: 'all 0.2s ease',
                           '&:hover': {
                              color: '#333'
                           }
                        },
                     }}
                     locale={{
                        last: 'Finish',
                        skip: 'skip',
                        next: 'Next',
                        back: 'Previous',
                     }}
                     floaterProps={{
                        disableAnimation: true,
                        hideArrow: false,
                        placement: 'right',
                        offset: 20,
                        styles: {
                           arrow: {
                              color: '#ffffff',
                              length: 16,
                              spread: 16,
                           },
                           floater: {
                              filter: 'drop-shadow(0 2px 5px rgba(0, 0, 0, 0.1))',
                           },
                        },
                     }}
                     tooltipComponent={({
                        continuous,
                        index,
                        size,
                        step,
                        backProps,
                        closeProps,
                        primaryProps,
                        tooltipProps,
                        isLastStep,
                        skipProps
                     }) => (
                        <div {...tooltipProps} style={{
                           padding: '32px',
                           borderRadius: '8px',
                           backgroundColor: '#ffffff',
                           width: '100%',
                           minWidth: '500px',
                           maxWidth: '800px',
                        }}>
                           <button {...skipProps} style={{
                              background: 'none',
                              border: 'none',
                              position: 'absolute',
                              right: '32px',
                              top: '32px',
                              color: '#777',
                              cursor: 'pointer',
                              fontSize: '16px',
                              transition: 'color 0.2s ease'
                           }}
                              onMouseEnter={(e) => e.target.style.color = '#333'}
                              onMouseLeave={(e) => e.target.style.color = '#777'}
                           >
                              Skip
                           </button>
                           <h2 style={{
                              margin: '0 0 16px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              color: '#333'
                           }}>
                              {step.title || 'Your control center'}
                           </h2>
                           <div style={{
                              margin: '0 0 32px 0',
                              fontSize: '16px',
                              lineHeight: 1.6,
                              color: '#555'
                           }}>
                              {step.content}
                           </div>
                           <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                           }}>
                              <div>
                                 {index > 0 && (
                                    <button
                                       {...backProps}
                                       style={{
                                          background: 'none',
                                          border: 'none',
                                          color: '#666',
                                          padding: '12px 0',
                                          fontSize: '16px',
                                          marginRight: '20px',
                                          cursor: 'pointer',
                                          transition: 'color 0.2s ease'
                                       }}
                                       onMouseEnter={(e) => e.target.style.color = '#333'}
                                       onMouseLeave={(e) => e.target.style.color = '#666'}
                                    >
                                       Previous
                                    </button>
                                 )}
                                 <button
                                    {...primaryProps}
                                    style={{
                                       backgroundColor: '#0040BF',
                                       color: 'white',
                                       padding: '12px 24px',
                                       fontSize: '16px',
                                       borderRadius: '4px',
                                       fontWeight: '500',
                                       border: 'none',
                                       cursor: 'pointer',
                                       transition: 'background-color 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#0033a0'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#0040BF'}
                                 >
                                    {isLastStep ? 'Finish' : 'Next'}
                                 </button>
                              </div>
                              <div style={{
                                 fontSize: '16px',
                                 color: '#666'
                              }}>
                                 {index + 1} of {size}
                              </div>
                           </div>
                        </div>
                     )}
                     callback={(data) => {
                        if (data.status === 'finished' || data.status === 'skipped') {
                           const userId = currentUser?.id;
                           if (userId) {
                              setRunTour(false);
                              setShowStartDialog(false);
                              handleCloseDialog()
                           }
                        }
                     }}
                  />
               )}
            </SidebarWrapper>
         )}

         {/* Mobile Sidebar */}
         {isMobile && (
            <>
               {mobileOpen && <MobileOverlay onClick={handleOverlayClick} />}
               <MobileSidebarWrapper
                  sx={{
                     transform: mobileOpen ? 'translateX(0)' : 'translateX(-100%)',
                  }}
               >
                  {renderSidebarContent()}
               </MobileSidebarWrapper>
            </>
         )}
      </>
   );
};

export default Sidebar;